/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { AuthRoles } from 'jotai/auth';
import { authService } from 'services/auth/AuthService';

const isXfinityUser = () => {
  const userRoles = authService.getRolesAllRealms();
  const authorizedXfinityRoles: string[] = [AuthRoles.ADMIN, AuthRoles.Xfinity];
  return userRoles && userRoles?.some((item) => authorizedXfinityRoles.includes(item));
};

export default isXfinityUser;
